import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { determineStorageUrl } from '../common/storage-tools';
import { Settings } from '../models/Settings';
import { FoodPortalStateService } from "../services/food-portal-state.service";
import { FoodPortalService } from '../services/food-portal.service';
import { InitalizeService } from "../services/initalize.service";
import { SlideMenuComponent } from "../slide-menu/slide-menu.component";

@Component({
    selector: "pi-shell",
    templateUrl: "./shell.component.html",
    styleUrls: ["./shell.component.scss"],
    standalone: false
})
export class ShellComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  showSplash: Observable<boolean>;
  showUnderConstruction: Observable<boolean>;
  showDisclaimer: Observable<boolean>;
  settings: Settings;
  @ViewChild("SlideMenu", { static: false }) slideMenu: SlideMenuComponent;
  storageUrl: string;

  constructor(
    private initializeService: InitalizeService,
    private svc: FoodPortalService,
    private router: Router,
    private stateSvc: FoodPortalStateService
  ) {
  }

  ngOnInit() {
    this.showSplash = this.initializeService.getSplashScreenSubscription();
    this.showUnderConstruction = this.initializeService.getUnderConstructionSubscription();
    this.showDisclaimer = this.initializeService.getShowDisclaimerSubscription();
    this.storageUrl = determineStorageUrl();

    this.svc
      .getPortalSettings()
      .subscribe((result) => {
        this.settings = result;

        this.initializeService.setEnterSplashScreenButton(
          this.settings && this.settings.enabled
        );
        this.initializeService.setSplashScreenLoading(false);

        if (!this.settings || !this.settings.enabled) {
          this.initializeService.setUnderConstructionScreen(true);
          this.initializeService.setSplashScreen(false);
          return;
        }
        if (this.settings && this.settings.forceDisclaimer) {
          this.initializeService.setShowDisclaimer(true);
        }
      });

    this.stateSvc.openMenu$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.toggleMenu();
    });
  }



  viewSplashScreen() {
    if (this.router.url.indexOf('recipe-list') !== -1) {
      this.initializeService.setSplashScreen(true);
    }
  }

  customerLogoClick() {
    if (this.settings.websiteUrl) {
      window.open(`//${this.settings.websiteUrl}`, '_blank');
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  toggleMenu() {
    this.slideMenu.showMenu = true;
  }
}
